import { Mesh } from "three";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import model from "../../../../../assets/models/GLB_Oxxo_V4.glb";
import gsap from "gsap";

export class MapOxxoTopicThree extends Mesh {
	constructor(loadingManager) {
		super();
		let loader = new GLTFLoader(loadingManager);
		let dracoloader = new DRACOLoader();
		dracoloader.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.5.5/");
		this.loading = loader;
		loader.setDRACOLoader(dracoloader);
		this.onLoadModel(loader);
		this.scale.set(2, 2, 2);

		this.productsRack = {
			miniProducts: [
				"Tortillas_1",
				"Tortillas_2",
				"Tortillas_3",
				"Tortillas_4",
			]
		}

		this.allProduct = [
			...this.productsRack.miniProducts,
		]
		// this.rotation.y = MathUtils.degToRad(90)
	}

	onLoadModel(loader) {
		loader.load(model, (gltf) => {
			this.add(gltf.scene);

			Object.values(this.allProduct).flat().forEach(objectName => {
				const currentObject = gltf.scene.getObjectByName(objectName, true);
				if (currentObject) {
					this.onChangueMaterial(currentObject);
				}
			});


			this.Fast_Food = gltf.scene.getObjectByName("Fast_Food", true);

			this.Mesh292 = gltf.scene.getObjectByName("Mesh292", true);
			this.onChangueMaterial(this.Mesh292)
			this.Puerta1 = gltf.scene.getObjectByName("Puerta1", true);
			this.Puerta_1 = gltf.scene.getObjectByName("Puerta_1", true);
			this.Puerta = gltf.scene.getObjectByName("Puerta", true);
			this.onChangueMaterial(this.Puerta)
			this.Mostrador = gltf.scene.getObjectByName("Mostrador", true);
			this.onChangueMaterial(this.Mostrador)
			this.Refri_1001 = gltf.scene.getObjectByName("Refri_1001", true);
			this.onChangueMaterial(this.Refri_1001)
			this.Refri_1 = gltf.scene.getObjectByName("Refri_1", true);
			this.onChangueMaterial(this.Refri_1)
			this.Puerta001 = gltf.scene.getObjectByName("Puerta001", true);
			this.onChangueMaterial(this.Puerta001)
			this.Ventanas = gltf.scene.getObjectByName("Ventanas", true);
			this.onChangueMaterial(this.Ventanas)
			this.Cloro_1 = gltf.scene.getObjectByName("Cloro_1", true);
			this.onChangueMaterial(this.Cloro_1)

			// iluminacion
			this.Mostrador001 = gltf.scene.getObjectByName("Mostrador001", true);
			this.Piso = gltf.scene.getObjectByName("Piso", true);
			this.Techo = gltf.scene.getObjectByName("Techo", true);
			this.Paredes = gltf.scene.getObjectByName("Paredes", true);
			this.Refri_coca_1 = gltf.scene.getObjectByName("Refri_coca_1", true);
			this.Estructura001 = gltf.scene.getObjectByName("Estructura001", true);
			this.Yelox = gltf.scene.getObjectByName("Yelox", true);
			this.Helado = gltf.scene.getObjectByName("Helado", true);

			const newMaterialPiso = this.Piso.material.clone();
			newMaterialPiso.color.set(0xd6d6d6);
			newMaterialPiso.emissiveIntensity = 2;
			newMaterialPiso.emissive.set("#2E2E2E");
			this.Piso.material = newMaterialPiso;
			const newMaterialTecho = this.Techo.material.clone();
			newMaterialTecho.color.set(0xffffff);
			newMaterialTecho.emissiveIntensity = 2;
			newMaterialTecho.emissive.set("#595959");
			this.Techo.material = newMaterialTecho;
			const newMaterialHelado = this.Helado.material.clone();
			newMaterialHelado.color.set(0xd1d1d1);
			newMaterialHelado.emissiveIntensity = 3.6;
			newMaterialHelado.emissive.set("#5E5E5E");
			this.Helado.material = newMaterialHelado;

			this.Paredes.material.emissiveIntensity = 2;
			this.Refri_coca_1.material.emissiveIntensity = 0.98;
			this.Yelox.material.emissiveIntensity = 2.58;
			this.Estructura001.material.emissive.set("#595959");
			this.Estructura001.material.emissiveIntensity = 1;
			this.Mostrador001.material.emissive.set("#737373");
			this.Mostrador001.material.emissiveIntensity = 2;

			// gltf.scene.traverse((child) => {
			// 	// Verifica si el hijo tiene un material antes de aplicar la opacidad
			// 	if (child.material) {
			// 		// Establece la opacidad del material del hijo en 0.2
			// 		child.material.opacity = 0.1;
			// 		// Asegúrate de que el material tenga transparencia activada
			// 		child.material.transparent = true;
			// 	}
			// });
		});
	}

	onChangueMaterial(object) {
		const newMaterial = object.material.clone();
		newMaterial.transparent = true
		object.material = newMaterial
	}


	clearAnimation() {
		if (this.animation) {
			this.animation.kill();
			this.animation = null
		}
		if (this.multiAnimationEmissive) {
			this.multiAnimationEmissive.kill()
			this.multiAnimationEmissive = null
			this.Mostrador001.material.emissiveIntensity = 1
			this.Mostrador.material.emissiveIntensity = 1
			this.Refri_1001.material.emissiveIntensity = 1
			this.Mesh292.material.emissiveIntensity = 1
			this.Ventanas.material.emissiveIntensity = 1
			this.Piso.material.emissiveIntensity = 2
			this.Puerta001.material.emissiveIntensity = 1
		}
	}

	clearAnimationNames(namesObj = []) {
		if (namesObj.length === 0) {
			return
		}

		if (this.multiAnimationEmissive) {
			this.multiAnimationEmissive.kill()
			this.multiAnimationEmissive = null
		}

		namesObj.forEach(objectName => {
			this.getObjectByName(objectName, true).material.emissiveIntensity = 1
		})

	}

	onAnimateEmissiveMultiIntensity(object = []) {
		this.clearAnimation()

		if (object.length === 0) {
			return
		}

		const materialObject = object.map((obj) => {
			return obj.material
		})

		this.multiAnimationEmissive = gsap.to(materialObject, {
			emissiveIntensity: 25,
			yoyo: true,
			repeat: -1,
			duration: 0.8,
			ease: "power1.inOut",
		});
	}

	onAnimationOpacity(object, callback = () => { }) {
		const newMaterial = object.material.clone();
		object.material = newMaterial;
		object.material.transparent = true
		gsap.to(object.material, {
			opacity: 0,
			duration: 2,
			onComplete: () => {
				callback()
			},
		});
	}

	onEmissiveMultipleName(object = [], callback = () => {

	}) {

		if (object.length === 0) {
			return
		}

		const objectSelectMaterial = object.map(objectName => {
			return this.getObjectByName(objectName, true).material
		})

		this.multiAnimationEmissive = gsap.to(objectSelectMaterial, {
			emissiveIntensity: 25,
			yoyo: true,
			repeat: -1,
			duration: 0.8,
			ease: "power1.inOut",
		});
	}

	renderAnimations() { }
}
